import styled, { keyframes } from 'styled-components'
import theme from '../../styles/theme'

const KeyframeArrow = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`

const StHero = styled.div`
  position: relative;
  overflow: hidden;
  .keffiyeh{
    max-width: 33vw;
    max-height: 30vh;
    display: block;
    position: absolute;
    left: 0;
    @media(max-width: 800px){
      position: static;
      margin-left: auto;
    }
  }
  .hero-content{
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    position: relative;
    min-height: ${props => props.minheight || '95vh'};
    max-width: ${theme.maxWidth};
    margin-left: auto;
    margin-right: auto;
    padding: 1rem;
    .hero-wrap{
      h1{
        font-weight: bold;
        max-width: ${theme.normalWidth};
        text-align: right;
        font-size: 6rem;
        line-height: 1;
      }
      p{
        max-width: ${theme.normalWidth};
        font-size: ${theme.fontsize};
		    line-height: ${theme.lineheight};
        text-align: right;
      }
    }
    .hero-more{
      position: absolute;
      bottom: 0;
      text-align: center;
      padding: 4rem;
      font-size: 1rem;
      .icon{
        display: block;
        margin: 12px auto 0;
        animation: ${KeyframeArrow} 1.5s ease-in-out 0s infinite;
      }
    }
  }
  .hero-bg{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    color: black;
    &:after{
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 20%;
      /* background: linear-gradient(transparent, ${theme.background}); */
    }
    .gatsby-image-wrapper{
      width: 100%;
      height: 100%;
    }
  }

`

export { StHero }